<script lang="ts">
    import type {Contract, ContractHistory, Employee} from "$lib/types/employee";
    import {Button, Hr, Input, Label, Modal, Select, Spinner} from "flowbite-svelte";
    import {getContext, onMount} from "svelte";
    import {tariffs} from "$lib/stores/tariffs";
    import {getTariffs} from "$lib/calls/tariff";
    import dayjs from "dayjs";
    import {asValue} from "$lib/utils/lenkradDate";
    import {templateDocuments} from "$lib/stores/templateDocuments";
    import {getDocumentTemplates} from "$lib/calls/settings";
    import {allUnits} from "$lib/stores/unit";
    import {getUnits} from "$lib/calls/unit";
    import {matchContractVariables} from "$lib/utils/templating/contractVariables";
    import wordDocumentParser from "$lib/utils/templating/wordDocumentParser";
    import {PUBLIC_API_PATH} from "$env/static/public";
    import {qualifications} from "$lib/stores/qualifications";
    import {unitQualifications} from "$lib/calls/qualification";
    import {formDataPost, post, put, retire} from "$lib/api";
    import {mailTemplates} from "$lib/stores/mailTemplates";
    import {getEmailTemplates, sendEmailTemplate} from "$lib/calls/mail";
    import EmailTemplateEditor from "$lib/components/EmailTemplateEditor.svelte";
    import type {EmailTemplate} from "$lib/types/EmailTemplate";
    import {findUnmatchedVariables} from "$lib/utils/templating/parseHandlebars";
    import {contractTypes} from "$lib/utils/templating/contractTypes";
    import VerticalGrid from "$lib/components/VerticalGrid.svelte";
    import CardLayout from "$items/CardLayout.svelte";
    import InfoBox from "$items/InfoBox.svelte";
    import {type Writable, writable} from "svelte/store";
    import {BuildingOutline} from "flowbite-svelte-icons";
    import ModalFooter from "$lib/components/ui/ModalFooter.svelte";
    import ModalHeader from "$lib/components/ui/ModalHeader.svelte";
    import {formatCurrency} from "$lib/utils/currency";
    import {PUBLIC_MAIL_FROM_EMAIL, PUBLIC_MAIL_FROM_NAME} from "$env/static/public";

    export let open: boolean = false;
    export let currentContract: Contract;
    export let employee: Employee;

    let previewForm: HTMLFormElement;
    let emailForm: HTMLFormElement;

    let currentHistory: ContractHistory;

    let contractTemplates:any[] = [];
    let units:any[] = [];
    let preview: Blob | null;

    let doneModal:Writable<boolean> = getContext('doneModal');



    let newTariffObject = {
        originalHistoryId: null,
        newTariffId: null,
        switchDate: dayjs().add(1, 'month').set('date', 1).format('YYYY-MM-DD'),
        file: null,
        newQualificationId: undefined
    }

    let changedObject;
    let mail: EmailTemplate|null = null;
    let input;
    let loading = false;
    let qualificationOptions: {value: string, name: string}[] = [];

    const render = async () => {
        console.log({newTariffObject, currentHistory})
        $forceEditable = false;
        loading = true;
        const template = contractTemplates.find(x => x.contractType === 'adjustment-tariff')
        const variables = matchContractVariables({
                ...employee,
                unit: units.find((u: any) => u.id === employee.unitId)},
            currentContract,
            {
                ...currentHistory,
                tariffId: newTariffObject.newTariffId,
                startDate: {value: newTariffObject.switchDate},

                qualificationId:$qualifications.find(x => x.id === newTariffObject.newQualificationId)?.id,
                qualification: $qualifications.find(x => x.id === newTariffObject.newQualificationId)
            },
            $tariffs,
            {
                fillInDate: newTariffObject.switchDate
            }, $qualifications)
        if(!template) {
            alert('Fehlende Vorlage')
        } else {
            preview = await wordDocumentParser(PUBLIC_API_PATH + '/template-document/' + template.id + '/binary', variables)
        }
        loading = false;
    }
    $: {
        /*if(!open && changedObject){
            reverse();
        }*/
        qualificationOptions = $tariffs.find(x => x.id === newTariffObject.newTariffId)?.qualifications?.map(x => ({value: x.qualificationId, name: $qualifications.find(y => y.id === x.qualificationId)?.title }))
    }

    let forceEditable = writable(true)
    const changeTariff = async () => {
        loading = true;
        newTariffObject.file = preview
        changedObject = await formDataPost(`/employee/${employee.uuid}/contract/${currentContract.id}/adjust`, newTariffObject)
        input = {
            formerLocalContractType: contractTypes.find(x => x.value === currentContract.contractType)?.name,
            formerLink: currentHistory.signatureLink,
            formerEndDate: dayjs(currentHistory.endDate.value).format('DD.MM.YYYY')
        }
        loading = false;
    }
    const sendEmail = async () => {
        loading = true;
        await sendEmailTemplate(mail?.id, {
            fromEmail: PUBLIC_MAIL_FROM_EMAIL,
            fromName: PUBLIC_MAIL_FROM_NAME,
            subject: 'Vertragsänderung_zwischen_' + employee.name + ' und Demo GmbH zur Signatur bereit!',
            entityId: employee.id,
            content: mail.content.replace(/<% body %>/g, ''),
            toEmail: employee.email,
            toName: employee.name,
            variables: findUnmatchedVariables(mail.content)
        })
        open = false;
        loading = false;
        $doneModal = true;
    }
    const reverse = async () => {
        if(changedObject){
            // update original
            await put(`/employee/${employee.uuid}/contract/${currentContract.id}/history/${currentHistory.id}`, currentHistory)
            // delete new
            await retire(`/employee/${employee.uuid}/contract/${currentContract.id}/history/${changedObject.newHistory.id}?silent=true`)
            // reset
            changedObject = undefined
        }
        preview = null;
        $forceEditable = true;

    }


    onMount(async () => {
        if($mailTemplates.length === 0){
            $mailTemplates = await getEmailTemplates();
        }
        if($tariffs.length === 0){
            $tariffs = await getTariffs();
        }
        if($qualifications.length === 0 || $qualifications.find(x => x.unitId === employee.unitId) === undefined){
            $qualifications = [...$qualifications, ...await unitQualifications(employee.unitId)];
        }
        if(currentContract){
            currentHistory = currentContract.currentHistory;
            newTariffObject.newTariffId = currentHistory.tariffId;
            newTariffObject.newQualificationId = currentHistory.qualificationId;
            newTariffObject.originalHistoryId = currentHistory.id;
        }
        contractTemplates = $templateDocuments;
        if($templateDocuments.length === 0){
            contractTemplates = await getDocumentTemplates()
            $templateDocuments = contractTemplates
        }
        units = $allUnits;
        if($allUnits.length === 0){
            units = await getUnits()
            $allUnits = units
        }
        qualificationOptions = $tariffs.find(x => x.id ===newTariffObject.newTariffId)?.qualifications?.map(x => ({value: x.qualificationId, name: $qualifications.find(y => y.id === x.qualificationId)?.title }))
        mail = $mailTemplates.find(x => x.name.includes('Qualifikations Änderung_sent'))
        console.log({qualificationOptions, qualifications: $qualifications, mail})
    })
</script>
<Modal size="lg" bind:open title="Tarif/Qualifikation ändern" >
    <svelte:fragment slot="header">
        <ModalHeader>Tarif/Qualifikation ändern</ModalHeader>
    </svelte:fragment>
    {#if currentHistory && !changedObject}
        <VerticalGrid>
            <InfoBox title="Aktueller Tarif" value="{$tariffs.find(x => x.id === currentHistory?.tariffId)?.name}" />
            <InfoBox title="Aktueller Grundlohn" value="{formatCurrency($tariffs.find(x => x.id === currentHistory?.tariffId)?.wagePerHour, 'EUR')}" />


            <svelte:fragment slot="right">
                <InfoBox title="Aktuelle Qualifikation" value="{$qualifications.find(x => x.id === currentHistory.qualificationId)?.title}" />
                <InfoBox title="Aktuelle Akontozahlung" value="{formatCurrency($tariffs.find(x => x.id === currentHistory?.tariffId)?.paymentOnAccount, 'EUR')}" />
            </svelte:fragment>

        </VerticalGrid>
        <Hr/>
        <form bind:this={previewForm} on:submit|preventDefault={render}>
            <VerticalGrid>

                <InfoBox on:change={ev => newTariffObject.newTariffId = parseInt(ev.detail.target.value)} name="tariffId" super_edit={forceEditable} type="select" title="Neuer Tarif" value="{newTariffObject.newTariffId}" items={$tariffs.filter(x => x.unitId === employee.unitId && x.visible).filter(x => x.wagePerHour > currentContract.currentHistory.wagePerHour).sort((a,b) => a.name.localeCompare(b.name)).map(x => ({name: x.name, value: x.id}))} />
                <InfoBox title="Neuer Grundlohn" value="{formatCurrency($tariffs.find(x => x.id === newTariffObject.newTariffId)?.wagePerHour, 'EUR')}" />
                <InfoBox on:change={ev => newTariffObject.switchDate = ev.detail.target.value} name="switchDate" super_edit={forceEditable} title="Beginn" type="date" value="{newTariffObject.switchDate}"  />

                <svelte:fragment slot="right">
                    <InfoBox on:change={ev => newTariffObject.newQualificationId = parseInt(ev.detail.target.value)} name="qualificationId" super_edit={forceEditable} title="Neue Qualifikation" type="select" items={qualificationOptions} value="{newTariffObject.newQualificationId}" />
                    <InfoBox title="Neue Akontozahlung" value="{formatCurrency($tariffs.find(x => x.id === newTariffObject.newTariffId)?.paymentOnAccount, 'EUR')}" />
                </svelte:fragment>

            </VerticalGrid>
        </form>

    {:else if changedObject}
        <p>E-Mail versenden</p>
        <form bind:this={emailForm} on:submit|preventDefault={sendEmail}>
            <Label class="space-y-2 mb-3">
                <span>Vorlage</span>
                <Select value={mail.id} on:change={(ev) => {mail = null; setTimeout(()=> mail = $mailTemplates.find(x => x.id === parseInt(ev.target.value)), 50)}}  items={$mailTemplates.filter(x => x.level === 'active' && x.name.includes('Qualifikations Änderung') ).map(x => ({value: x.id, ...x}))}/>
            </Label>
            {#if mail}
                <EmailTemplateEditor  on:update={e => mail = e.detail} preview={true} template={mail} fillData={{Employee: employee, Contract: changedObject.newHistory, Input: input, Unit: $allUnits.find(x => x.id === employee.unitId)}} />
            {/if}
        </form>
    {/if}
    <svelte:fragment slot="footer">
        <ModalFooter disabled={loading} showEdit={!!preview} on:abort={() => {reverse(); open = false}} on:edit={reverse}>
            <svelte:fragment slot="right">
                {#if !preview}
                    <Button disabled={loading} class="bg-sky-100 text-neutral-600 whitespace-nowrap" on:click={() => previewForm.requestSubmit()}>Vorschau erstellen</Button>
                {:else}
                    <Button disabled={loading} type="button" download="Anpassung_{employee.name.replaceAll(' ','_')}.docx" href={URL.createObjectURL(preview)} target="_blank" color="light">Vorschau erzeugter Vertrag</Button>
                    {#if !changedObject}
                        <Button disabled={loading} class="bg-sky-100 text-neutral-600 whitespace-nowrap"  on:click={() => changeTariff()} >Änderung durchführen</Button>
                    {:else}
                        <Button disabled={loading} class="bg-sky-100 text-neutral-600 whitespace-nowrap" on:click={() => emailForm.requestSubmit()}>E-Mail senden</Button>
                    {/if}
                {/if}

            </svelte:fragment>
        </ModalFooter>
    </svelte:fragment>

</Modal>